import PropTypes from "prop-types";
import React, { useRef } from "react";

import styled from "styled-components/macro";

import FnrButton from "UI/FnrButton3";
import { FnrPopover } from "UI/FnrPopover2";

ErrorPopover.propTypes = {
  show: PropTypes.bool,
  setShow: PropTypes.func,
  message: PropTypes.string,
};

export default function ErrorPopover({ handleClose, message }) {
  const buttonRef = useRef();

  return (
    <Wrapper ref={buttonRef}>
      <FnrPopover
        show={message && message.length}
        buttonRef={buttonRef}
        onShouldClose={handleClose}
        style={{
          backgroundImage:
            "linear-gradient( to right bottom, rgba(180, 37, 45, 0.7), rgba(128, 36, 40, 0.7) )",
        }}
      >
        <Content>
          <Title>Uh oh!</Title>
          <Message>{message}</Message>
          <Button>
            <FnrButton onClick={handleClose}>Ok</FnrButton>
          </Button>
        </Content>
      </FnrPopover>
    </Wrapper>
  );
}

const Wrapper = styled.div``;

const Title = styled.div`
  font-size: 22px;
  padding-bottom: 2px;
  margin-bottom: 4px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
`;

const Content = styled.div`
  display: flex;
  flex-flow: column;
  padding: 6px 10px;
  max-width: 240px;
`;

const Message = styled.div``;

const Button = styled.div`
  margin-top: 12px;
  align-self: flex-end;
`;
